<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import router from "../../router";
import moment from "moment";

import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'

export default {
  name: "Inventory History",
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    CustomerDateRangePicker
  },
  data() {
    return {
      date: {
        startDate: "",
        endDate: ""
      },
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      storeList: [],
      employeeList: [],
      currentSorting: "",
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        search: "",
        reference_type: "",
        employee_id: "",
        to_date: "",
        from_date: ""
      }
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy, store_id) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );
      this.$api
        .getAPI({
          _action:
            "/inventory_count/inventory_history/" +
            this.itemsPerPage +
            "/" +
            page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(this.$lang.messages.no_inventory_history_found);
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },

    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },
    retry() {
      this.getList(1);
    },
    getEmployeeList() {
      this.$api
        .getAPI({ _action: `/employee/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
        })
        .catch(e => {});
    },
    details(type, id, number) {


      if(number.startsWith("PO")){
        router.push("/view-purchase-order/" + id);
      }else if(number.startsWith("SA")){
        router.push("/view-stock-adjustment/" + id);
      }else if(number.startsWith("IC")){
        router.push("/view-inventory-count/" + id);
      }else if(number.startsWith("TO")){
        router.push("/view-transfer-order/" + id);
      }
      else{
        router.push("/sales_receipts");
      }
    },
    getExport() {
      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }

      this.$api.getAndDownloadAPI({ _action: "/inventory_count/export_inventory_history/" +
          localStorage.getItem("client_id") +
          queryParam
        , _fileName: 'inventory_history.csv'})
    }
  },
  mounted() {

    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );
    this.getStoreList();
    this.getList(1);
    this.getEmployeeList();
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12 d-lg-flex justify-content-end">
            <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
              <CustomerDateRangePicker
              class="w-xs-100"
              :date.sync="date"
              @update="getList(1)"></CustomerDateRangePicker>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;">
              <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_stores}}</option>
                <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
              </select>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 mllg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;">
              <select v-model="filterObj.employee_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_employees}}</option>
                <option
                  v-for="employee in employeeList"
                  :key="employee.id"
                  :value="employee.id"
                >{{employee.name}}</option>
              </select>
            </div>

            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 mllg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;">
              <select class="form-control" v-model="filterObj.reference_type" @change="getList(1)">
                <option value>{{$lang.messages.all_reasons}}</option>
                <option value="SOLD">{{$lang.messages.sold}}</option>
                <option value="RETURNED">{{$lang.messages.return}}</option>
                <option value="RECEIVED">{{$lang.messages.received}}</option>
                <option value="TRANSFERRED">{{$lang.messages.transfer}}</option>
                <option value="RECOUNTED">{{$lang.messages.recounted}}</option>
                <option value="DAMAGED">{{$lang.messages.damaged}}</option>
                <option value="LOST">{{$lang.messages.lost}}</option>
                <option value="ITEM_ADD">{{$lang.messages.item_add}}</option>
                <option value="PRODUCTION">{{$lang.messages.production}}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card rounded-5">
              <div class="bg-white mt-3">
                <div class="pink-tape py-1">
                  <div class="row">
                    <div class="col-md-8 col-5 align-self-center pt-1">
                      <a
                        href="javascript:void(0)"
                        class="font-22 mb-0 text-regular text-hover-primary"
                        @click="getExport()"
                      >
                        {{$lang.messages.export}}
                        <i class="mdi mdi-download align-text-top"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-white mt-3"></div>
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col">{{$lang.messages.date}}</th>
                      <th scope="col">{{$lang.messages.item}}</th>
                      <th scope="col">{{$lang.messages.store}}</th>
                      <th scope="col">{{$lang.messages.employee}}</th>
                      <th scope="col">{{$lang.messages.reason}}</th>
                      <th scope="col" class="text-center">{{$lang.messages.adjustment}}</th>
                      <th scope="col" class="text-center">{{$lang.messages.stock_before}}</th>
                      <th scope="col" class="text-center">{{$lang.messages.stock_after}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,i) in list" :key="item.id">
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td>{{item.created_at | moment("MMM DD, YYYY") }}</td>
                      <td>{{item.item_name}} {{item.item_variant_combination_name ? "- " + item.item_variant_combination_name : ""}}</td>
                      <td>{{item.store_name}}</td>
                      <td>{{item.employee_name}}</td>
                      <td>
                        <span v-if="item.reference_type == 'SOLD'">{{$lang.messages.sold}}</span>
                        <span
                          v-else-if="item.reference_type == 'ITEM_ADD'"
                        >{{$lang.messages.item_add}}</span>
                        <span
                          v-else-if="item.reference_type == 'RETURNED'"
                        >{{$lang.messages.return}}</span>
                        <span v-else-if="item.reference_type == 'LOST'">{{$lang.messages.lost}}</span>
                        <span
                          v-else-if="item.reference_type == 'DAMAGED'"
                        >{{$lang.messages.damaged}}</span>
                        <span
                          v-else-if="item.reference_type == 'RECOUNTED'"
                        >{{$lang.messages.recounted}}</span>
                        <span
                          v-else-if="item.reference_type == 'RECEIVED'"
                        >{{$lang.messages.received}}</span>
                        <span
                          v-else-if="item.reference_type == 'PRODUCTION'"
                        >{{$lang.messages.production}}</span>
                        <span
                          v-else-if="item.reference_type == 'TRANSFERRED'"
                        >{{$lang.messages.transferred}}</span>
                        <span
                          class="text-success"
                          @click="details(item.reference_type, item.reference_type_id, item.number)"
                        >{{item.reference_type == 'ITEM_ADD' ? '' : '#'}}{{item.number}}</span>
                      </td>
                      <td class="text-center">{{item.adjustment}}</td>
                      <td class="text-center">{{item.stock_before}}</td>
                      <td class="text-center">{{item.stock_after}}</td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
